import { Tabs } from "tailwindcss-stimulus-components"

export default class PersistTabs extends Tabs {

  static values = {
    key: String,
    defaultTab: String
  }
  connect() {
    super.connect();
    this.key = this.keyValue || 'missionShowActiveTab';
    this.restoreTab();
    this.element.querySelectorAll(this.tabSelector).forEach(tab => {
      tab.addEventListener("click", this.saveTab.bind(this));
    });

    // Listen for Turbo frame/page refreshes
    document.addEventListener("turbo:frame-load", this._restoreTabAfterTurbo = this.restoreTab.bind(this));
    document.addEventListener("turbo:load", this._restoreTabAfterTurbo);

    // Card #2633 fix -- a Turbo MORPH refresh (application.html.erb sets
    // `turbo_refreshes_with method: :morph`, which is what
    // airdrop_report_viewer_controller.js#reloadPage's
    // `Turbo.visit(url, { action: "replace" })` triggers for a same-URL
    // visit) preserves this element across the refresh -- Idiomorph matches
    // it to the incoming HTML and patches it IN PLACE rather than
    // destroying/recreating it, so connect() never fires again and neither
    // `turbo:load` NOR `turbo:frame-load` above ever catch it (those only
    // fire for a genuine hard Drive navigation or a frame load, not a page
    // morph -- Turbo dispatches the DISTINCT `turbo:morph` event for that).
    // Meanwhile every `panelTarget` is re-rendered by the SERVER with its
    // default "hidden" class (the server has no notion of client-side tab
    // state), and Idiomorph patches that class straight onto the live,
    // previously-unhidden panel to match -- so without this listener, ANY
    // page using persist-tabs (14 views) that receives a morph refresh
    // loses its active tab entirely, every panel ends up hidden. Re-running
    // showTab() (not restoreTab(), which only acts when a NEW tab needs
    // restoring from storage/URL and is a no-op here) re-applies THIS
    // controller's own still-current indexValue -- unaffected by the morph,
    // since it was never written back to a DOM attribute -- onto the
    // fresh (reverted-to-hidden) panels, restoring exactly the tab that was
    // showing before the refresh.
    //
    // Card #2643 UPDATE: the deck show page's reloadPage no longer triggers
    // this at all (it now applies a scoped Turbo Stream instead of visiting
    // the page) -- but persist-tabs is shared across 14 views, none of which
    // were individually audited for some OTHER same-URL Drive visit or
    // refresh trigger of their own, so this listener stays in place rather
    // than being removed speculatively.
    document.addEventListener("turbo:morph", this._reshowTabAfterMorph = this.showTab.bind(this));
  }

  disconnect() {
    // Clean up event listeners
    document.removeEventListener("turbo:frame-load", this._restoreTabAfterTurbo);
    document.removeEventListener("turbo:load", this._restoreTabAfterTurbo);
    document.removeEventListener("turbo:morph", this._reshowTabAfterMorph);
    super.disconnect && super.disconnect();
  }

  change(event) {
    super.change(event);
    this.saveTab(event);
  }

  saveTab(event) {
    const tab = event.currentTarget;
    const tabId = tab.dataset.tab;
    if (tabId) {
      localStorage.setItem(this.key, tabId);
    }{
      localStorage.setItem(this.key, tabId);
    }
  }

  restoreTab() {
    // URL query param takes priority (e.g. ?tab=downloads)
    const urlTab = new URLSearchParams(window.location.search).get("tab");
    const lastTab = urlTab || localStorage.getItem(this.key) || this.defaultTabValue;
    if (lastTab) {
      const tabToShow = this.tabTargets.find(tab => tab.dataset.tab === lastTab);
      if (tabToShow) tabToShow.click();
    }
  }
}
